import { render } from "./thinkSellGoods.vue?vue&type=template&id=33225ee9&scoped=true"
import script from "./thinkSellGoods.vue?vue&type=script&lang=js"
export * from "./thinkSellGoods.vue?vue&type=script&lang=js"

import "./thinkSellGoods.vue?vue&type=style&index=0&id=33225ee9&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33225ee9"]])

export default __exports__